import React from "react";
import { Field } from "redux-form";
import { styleModules } from "shared/ui/material-ui-styles/use-style-imputs";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";
import classNames from "classnames";

class CustomBoolean extends React.Component {
  render() {
    const { wrapperClassName, customField, isEmbedded, classes } = this.props;

    if (!isEmbedded) {
      return (
        <div className={wrapperClassName}>
          <Field
            name={`custom_fields_hash.${customField.get("name")}`}
            component="input"
            type="checkbox"
            id={customField.get("name")}
          />
          <label className="p-sm-l" htmlFor={customField.get("name")}>
            {customField.get("label")}
          </label>
        </div>
      );
    } else {
      return (
        <div
          className={classNames(wrapperClassName, {
            [classes.rootBool]: !!classes.rootBool,
          })}>
          <Field
            name={`custom_fields_hash.${customField.get("name")}`}
            component="input"
            type="checkbox"
            id={customField.get("name")}
          />
          <label
            className={classNames("p-sm-l", { [classes.labelBool]: !!classes.labelBool })}
            htmlFor={customField.get("name")}>
            {customField.get("label")}
          </label>
        </div>
      );
    }
  }
}

CustomBoolean.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styleModules)(CustomBoolean);
